import { memo, type PropsWithChildren } from 'react';
import QueryBuilderProvider from "./QueryBuilderProvider";
import ConditionTextArea from 'ui/screens/QueryBuilder/ConditionTextArea';

interface Condition {
    dropdown1: string;
    dropdown2: string;
    inputValue: string;
    condition: string;
}

interface Aggregation {
    dropdown1: string;
    dropdown2: string;
    aggregation: string;
}

interface Sort {
    dropdown1: string;
    dropdown2: string;
    sort: string;
}

interface QueryBuilderProps {
    updatedConditions: Condition[];
    updatedAggregations: Aggregation[];
    updatedSorts: Sort[];
    onConditionTextAreaChange: (value: string) => void;
}

const QueryBuilder = ({
    children,
    updatedConditions,
    updatedAggregations,
    updatedSorts,
    onConditionTextAreaChange
}: PropsWithChildren<QueryBuilderProps>) => (
    <QueryBuilderProvider>
        <ConditionTextArea
            updatedConditions={updatedConditions}
            updatedAggregations={updatedAggregations}
            updatedSorts={updatedSorts}
            onChange={onConditionTextAreaChange}
        />
        {children}
    </QueryBuilderProvider>
);

export default memo(QueryBuilder);